module.exports = "/_next/static/images/SKRILL-4508bf0749df7e87101dff781db16157.png";